/**
@ngdoc directive
@name refreshStatus

@description
Refresh the Status of an object.<br />
Often used where the resultant Status does not occur immediately and<br />
a intermediate Status is displayed until the resultant Status occurs.

@param {url} refresh-status URL to collect latest JSON information about the Status
@param {integer=} refresh-status-attempts number attempts to refresh the status
@param {integer=} refresh-status-interval number of seconds before next attempt

@examples
	http://localhost:8080/testSearch/refreshStatus

*/
(function() {
	'use strict';

	var refreshStatus = function($interval, $http) {
		return {
			restrict: "A",
			scope: true,
			bindToController: {
			   ajaxUrl: "@refreshStatus",
			   numberOfAttempts: "@refreshStatusAttempts",
			   intervalInSeconds: "@refreshStatusInterval"
			},
			controllerAs: 'ctrl',
			controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
				var _this = this;

				this.$onInit = function(){
					$scope.originalStatus = $element.text();
					$scope.status 		  = $element.text();
					$scope.ajaxUrl 		  = _this.ajaxUrl;

					$scope.spinnerHtml = '<i class="loading-spinner link-spinner"></i>';

					$scope.milliseconds = 3000; //default
					if(angular.isDefined(_this.intervalInSeconds)){
						$scope.milliseconds = _this.intervalInSeconds * 1000;
					}

					$scope.numberOfAttempts = 100; //default
					if(angular.isDefined(_this.numberOfAttempts)){
						$scope.numberOfAttempts = _this.numberOfAttempts;
					}
				}
			}],
			link: function(scope, element, attr){
				var DEBUG = false,
					DEBUG_AJAX = false;

				var refreshStatusId,
					attemptNumber = 0;

				//Stop the refresh changes and set the status
				var stopRefresh = function(){
					// if(DEBUG) console.log('refreshStatus.setStatusAndStopRefresh()', scope.ajaxUrl, attemptNumber);
					$interval.cancel(refreshStatusId);
				}

				var setStatus = function(status){
					element.text(status);
				}

				var resetStatus = function(){
					element.text(scope.originalStatus);
				}

				//Alter status if status has changed
				var alterStatus = function(data){
					if(DEBUG) {
						console.log('refreshStatus.alterStatus()', scope.ajaxUrl, attemptNumber);
					}
					//{"id":272813,"status":{"id":4954,"name":"Processing","changed":false},"actionUrl":""}
					if(data.status.changed == true){
						stopRefresh();
						setStatus(data.status.name);
					} else {
						if(DEBUG_AJAX) {
							setStatus( scope.originalStatus + ' ' + attemptNumber + ' ' + (new Date()).getSeconds() );
						}
					}
				}

				//Make the JSON AJAX call
				var getStatus = function(){
					if(DEBUG) {
						console.log('refreshStatus.getStatus()', scope.ajaxUrl, attemptNumber);
					}
					$http.get(scope.ajaxUrl)
						.then(function(response){
							alterStatus(response.data);
						}, function(response){
							//something is wrong - at the moment I'll let subsequent attempts through
						}
					);
				}

				var checkStatus = function(){
					attemptNumber++;
					if(DEBUG) {
						console.log('refreshStatus.checkStatus()', scope.ajaxUrl, attemptNumber);
					}

					if(attemptNumber == 1){
						element.prepend(scope.spinnerHtml); //prepend a spinner
					}
					if(attemptNumber<=scope.numberOfAttempts){
						getStatus();
					} else {
						stopRefresh();
						resetStatus();
					}
				};

				//Stop the refresh changes
				element.on('$destroy', function() {
			    	stopRefresh();
					resetStatus();
			    });

				// Start the refresh status process. Save the refreshStatusId for canceling
				refreshStatusId = $interval(function(){
					checkStatus();
				}, scope.milliseconds);
			},
			replace: false,
			transclude: false
		};
	}
	refreshStatus.$inject = ['$interval', '$http'];
	angular.module('app').directive('refreshStatus', refreshStatus);

}());
